import * as React from "react";
import { RecommendationItem } from "../../calcBusterTypes";
import { SpaceBetween, StatusIndicator } from "@amzn/awsui-components-react";

const RecommendationStatuses = (recommendations: RecommendationItem[]) => {
  if (!recommendations) {
    return "No recommendations";
  }
  const high = recommendations.filter(
    (recommendations) => recommendations.severity === "High"
  ).length;
  const medium = recommendations.filter(
    (recommendations) => recommendations.severity === "Medium"
  ).length;
  const low = recommendations.filter(
    (recommendations) => recommendations.severity === "Low"
  ).length;

  return (
    <SpaceBetween size="m" direction="horizontal">
      <StatusIndicator type="error">{high}</StatusIndicator>
      <StatusIndicator type="warning">{medium}</StatusIndicator>
      <StatusIndicator type="info">{low}</StatusIndicator>
    </SpaceBetween>
  );
};

export default RecommendationStatuses;
